//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    resources: {
      required: true,
    },
  },
  data() {
    return {
      slideCounter: 0,
    };
  },
  computed: {
    maxCounter() {
      let counter = 0;
      if (this.resources.main_guide)
        counter = counter + this.resources.main_guide.length;
      if (this.resources.secondary_guide)
        counter =
          counter + Math.ceil(this.resources.secondary_guide.length / 2);
      return counter - 3;
    },
  },
  methods: {},
};
